import React from 'react';
import { Routes, Route } from 'react-router';
import { useAuth } from '../hooks/useAuth';
import Login from '../components/auth/Login';
import Admin from '../components/admin/Admin';
import Stocks from '../components/stocks/Stocks';
import PriceChecker from '../components/priceChecker/PriceChecker';
import Dashboard from '../components/dashboard/Dashboard';
import SalePickingListPage from '../components/picking/SalePickingListPage';
import PickingWorkspacePage from '../components/picking/PickingWorkspacePage';
import StocktakeListPage from '../components/stocktake/StocktakeListPage';
import StocktakeWorkspacePage from '../components/stocktake/StocktakeWorkspacePage';
import { HandlePrivateRoutes, HandlePublicRoutes, HandleLogout } from './RouteHandlers';
import routes from './routes';


const Routing = () => {
  const { authState, logoutUser } = useAuth();
  const { isAuthenticated, user } = authState;
  console.log('Routing->authData', { isAuthenticated, user });
  return (
    <Routes>
      <Route path={routes.login} element={<HandlePublicRoutes isAuthenticated={isAuthenticated} user={user}><Login /></HandlePublicRoutes>} />
      <Route path={routes.admin} element={<HandlePrivateRoutes isAuthenticated={isAuthenticated} user={user}><Admin /></HandlePrivateRoutes>} />
      <Route path={routes.stocks} element={<HandlePrivateRoutes isAuthenticated={isAuthenticated} user={user}><Stocks /></HandlePrivateRoutes>} />
      <Route path={routes.priceChecker} element={<HandlePrivateRoutes isAuthenticated={isAuthenticated} user={user}><PriceChecker /></HandlePrivateRoutes>} />
      <Route path={`${routes.picking}/:saleId`} element={<HandlePrivateRoutes isAuthenticated={isAuthenticated} user={user}><PickingWorkspacePage /></HandlePrivateRoutes>} />
      <Route path={routes.picking} element={<HandlePrivateRoutes isAuthenticated={isAuthenticated} user={user}><SalePickingListPage /></HandlePrivateRoutes>} />
      <Route path={`${routes.stocktake}/:stocktakeId`} element={<HandlePrivateRoutes isAuthenticated={isAuthenticated} user={user}><StocktakeWorkspacePage /></HandlePrivateRoutes>} />
      <Route path={routes.stocktake} element={<HandlePrivateRoutes isAuthenticated={isAuthenticated} user={user}><StocktakeListPage /></HandlePrivateRoutes>} />
      <Route path={routes.root} element={<HandlePrivateRoutes isAuthenticated={isAuthenticated} user={user}><Dashboard /></HandlePrivateRoutes>} />
      <Route path={routes.logout} element={<HandleLogout logoutUser={logoutUser} />} />
      <Route path="*" element={<HandlePrivateRoutes isAuthenticated={isAuthenticated} user={user} />} />
    </Routes>
  );
};

export default Routing;